<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="$emit('close')">
      <div class="howto" role="dialog" aria-modal="true" aria-label="How to play">
        <button class="howto__close icon-button" aria-label="Close" @click="$emit('close')">×</button>
        <div class="howto__body">
          <h3>{{ slide.title }}</h3>
          <p v-for="(line, i) in slide.lines" :key="i" class="howto__line" v-html="line" />
        </div>
        <div class="howto__nav">
          <button class="secondary" :disabled="index === 0" @click="index -= 1">Back</button>
          <span class="howto__dots">
            <span v-for="(s, i) in slides" :key="i" class="howto__dot" :class="{ 'howto__dot--on': i === index }" />
          </span>
          <button v-if="index < slides.length - 1" class="primary howto__next" @click="index += 1">Next</button>
          <button v-else class="primary howto__next" @click="$emit('close')">Start</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { UNHAPPY_AT } from '@/engine/constants';

export const SLIDES = [
  {
    title: 'One commonwealth, four roles',
    lines: [
      'A <strong>cooperative</strong> game: everyone wins or loses together.',
      'Four roles, four games. The <strong>Hall</strong> plays cards onto a council. The <strong>Stewards</strong> staff the city. The <strong>Scholars</strong> solve the principles to learn technologies. The <strong>Frontier</strong> commands units on the map.',
      'Your phone is your board, with a ? for help. The TV shows the world.',
    ],
  },
  {
    title: 'A round',
    lines: [
      '<strong>Dawn.</strong> Split the workers between the roles - anyone can tap, so talk it over. Food, goods, coin and knowledge are shared.',
      '<strong>Day.</strong> Everyone plays at once, then presses Done.',
      '<strong>The card.</strong> The TV turns an event; any choice on it is everyone\'s.',
      `<strong>Night.</strong> The people eat; stores over the cap spoil; camps send raiders. Happiness ${UNHAPPY_AT} or less halves tomorrow's workers.`,
    ],
  },
  {
    title: 'The deck, and the world',
    lines: [
      '<strong>What you do adds cards</strong> to the deck, near the top: consequences you meet later. A new season is dealt when it runs out.',
      '<strong>Other peoples</strong> share the island. Gifts make them friendly; refusals make them hostile.',
    ],
  },
  {
    title: 'Winning and losing',
    lines: [
      'Raise <strong>wonders</strong> together; each gives something for good. Four <strong>victories</strong> are on the table from the start, far off; the first one reached ends the campaign.',
      'A round is a <strong>month</strong>; twelve make a year, and a year is one sitting. January names the year\'s goal, September is the Harvest, and December\'s <strong>Midwinter</strong> writes the chronicle and keeps a tale.',
      'You lose if happiness hits 0, the people are gone, or raiders sack a city with nothing left standing.',
    ],
  },
];

export default {
  name: 'HowToPlay',
  emits: ['close'],
  data() { return { index: 0, slides: SLIDES }; },
  computed: { slide() { return this.slides[this.index]; } },
};
</script>
